import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.constructor";
import i18n from "../i18n";
export function getValidateCodeMsg(code) {
  return checkCode(code) ? '' : i18n.t('validator.code');
}
export function checkNum(value) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var reg = new RegExp('^\\d+\\.?\\d{0,' + limit + '}$');
  return reg.test(value);
}
export function getRateValidator(emptyMsg, errorMsg) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return function (val) {
    if (val.length === 0) {
      return emptyMsg;
    }
    if (checkNum(val, limit)) {
      return '';
    }
    return errorMsg;
  };
}
export function checkCode(value) {
  return value.length === 6 && /^[0-9]+$/.test(value);
}
export function checkPassword(value) {
  return value.length > 5 && value.length < 33;
}
export function checkEmail(value) {
  return /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{1,13})$/.test(value);
}
export function getIpMsg(ipStr) {
  if (!ipStr) {
    return i18n.t('validator.ip');
  }
  var list = ipStr.split(',');
  if (list.length > 10) {
    return i18n.t('validator.ipsInvalid');
  }
  if (list.length !== new Set(list).size) {
    return i18n.t('validator.ipsSame');
  }
  var reg = /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/;
  return list.every(function (item) {
    return reg.test(item);
  }) ? '' : i18n.t('validator.ipsInvalid');
}